import React from "react";
import PolicyLayout, { Section, Bullets } from "@/components/PolicyLayout";
import { Mail, Globe } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <PolicyLayout title="Privacy Policy" tagline="Legal · Privacy" updated="Feb 2026">
      <p>
        Welcome to Teuralink ("Teuralink," "we," "our," or "us"). We value your trust and are committed
        to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and
        safeguard your information when you visit www.teuralink.com or purchase our commemorative products.
      </p>

      <Section n={1} title="Information We Collect">
        <p className="mb-2">We may collect the following information:</p>
        <div className="mt-3">
          <div className="overline mb-2">Personal Information</div>
          <Bullets items={[
            "Full Name",
            "Email Address",
            "Mobile Number",
            "Billing Address",
            "Shipping Address",
            "Recipient Information (for gift orders)",
          ]} />
        </div>
        <div className="mt-5">
          <div className="overline mb-2">Payment Information</div>
          <p>
            Payments are processed securely through trusted third-party payment gateways. Teuralink
            does not store your credit card, debit card, UPI PIN, banking passwords, or other sensitive
            payment credentials.
          </p>
        </div>
      </Section>

      <Section n={2} title="How We Use Your Information">
        <p className="mb-2">We use your information to:</p>
        <Bullets items={[
          "Process and deliver orders",
          "Personalize commemorative certificates",
          "Deliver physical gift packages",
          "Verify registry records",
          "Provide customer support",
          "Improve our website and services",
          "Detect fraudulent activity",
          "Comply with applicable legal obligations",
        ]} />
      </Section>

      <Section n={3} title="Information Sharing">
        <p>We do not sell or rent your personal information.</p>
        <p className="mt-2 mb-2">We may share information only with:</p>
        <Bullets items={[
          "Payment Service Providers",
          "Shipping & Courier Partners",
          "Technology Service Providers",
          "Government Authorities when legally required",
        ]} />
      </Section>

      <Section n={4} title="Data Security">
        <p>
          We implement commercially reasonable administrative, technical, and physical safeguards to
          protect your information against unauthorized access, alteration, disclosure, or destruction.
        </p>
      </Section>

      <Section n={5} title="Cookies">
        <p>
          We use cookies to enhance website functionality, improve user experience, and analyze website traffic.
        </p>
      </Section>

      <Section n={6} title="Your Rights">
        <p className="mb-2">You may request:</p>
        <Bullets items={[
          "Access to your personal information",
          "Correction of inaccurate information",
          "Deletion of eligible personal information",
          "Withdrawal of marketing communications",
        ]} />
      </Section>

      <Section n={7} title="Policy Updates">
        <p>
          We may update this Privacy Policy from time to time. Any changes will be published on this page
          with an updated Effective Date.
        </p>
      </Section>

      <Section n={8} title="Contact Us">
        <p className="mb-3">For privacy-related questions, please contact:</p>
        <div className="p-5 border border-white/10 rounded-xl bg-white/[0.02]">
          <div className="font-display text-xl text-white">Teuralink</div>
          <div className="mt-3 space-y-2 text-sm">
            <div className="flex items-center gap-2"><Globe className="w-4 h-4 text-gold" /> www.teuralink.com</div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> support@teuralink.com</div>
          </div>
        </div>
      </Section>
    </PolicyLayout>
  );
}
